module.exports = "/assets/data/f8a1973b195cef547ff034a3e07ad15e-RM11.data.json";